
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Database"}},[_c('path',{attrs:{"d":"M18.152 18.885a40.847 40.847 0 01-3.854-.871 1 1 0 10-.542 1.925 43.26 43.26 0 004.042.915 1.078 1.078 0 00.178.015 1 1 0 00.176-1.984zM22.062 19.457a1 1 0 10-.229 1.986A89.287 89.287 0 0032 22a89.366 89.366 0 0010.141-.554 1 1 0 10-.228-1.986A87.455 87.455 0 0132 20a87.345 87.345 0 01-9.938-.543zM22.062 35.457a1 1 0 10-.229 1.986A89.287 89.287 0 0032 38a89.366 89.366 0 0010.141-.554 1 1 0 10-.228-1.986A87.455 87.455 0 0132 36a87.345 87.345 0 01-9.938-.543zM41.913 51.46A87.455 87.455 0 0132 52a87.345 87.345 0 01-9.938-.543 1 1 0 10-.229 1.986A89.287 89.287 0 0032 54a89.366 89.366 0 0010.141-.554 1 1 0 10-.228-1.986zM18.152 34.885a40.847 40.847 0 01-3.854-.871 1 1 0 10-.542 1.925 43.26 43.26 0 004.042.915 1.078 1.078 0 00.178.015 1 1 0 00.176-1.984zM18.152 50.885a40.847 40.847 0 01-3.854-.871 1 1 0 10-.542 1.925 43.26 43.26 0 004.042.915 1.078 1.078 0 00.178.015 1 1 0 00.176-1.984z"}}),_c('path',{attrs:{"d":"M49.135 3.186A109.613 109.613 0 0032 2a109.613 109.613 0 00-17.135 1.186C7.894 4.347 7 5.834 7 7v48c0 4.6 12.577 7 25 7s25-2.4 25-7V7c0-1.166-.894-2.653-7.865-3.814zM55 39c0 2.039-8.96 5-23 5S9 41.039 9 39V26.815C13.519 29.523 24.7 30 32 30s18.481-.477 23-3.185zm0-15c0 1.661-7.136 4-23 4S9 25.661 9 24V10.815C13.519 13.523 24.7 14 32 14s18.481-.477 23-3.185zM9 7.076C9.741 6.015 17.321 4 32 4s22.259 2.015 23 3.076V8c0 1.661-7.136 4-23 4S9 9.661 9 8zM32 60c-14.04 0-23-2.961-23-5V41.924C13.029 44.609 22.556 46 32 46s18.971-1.391 23-4.076V55c0 2.039-8.96 5-23 5z"}})])])
          )
        }
      }
    